import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import FireLog from '../../components/locations/FireLog';
import PopupBox from '../../components/shared/PopupBox';
import EmergencyHeader from '../../components/header/EmergencyHeader';
import { request, handleRequestErrors } from '../../helpers/Requests';

class FireLogIndex extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    location: "",

    locations: [],
    loaded: false,
    key: 0,
    unauthorized: ""
  };

  handleChange(event) {
    let name = event.target.name;
    var value = event.target.value;

    this.setState({
      [name]: value
    });
  }

  displayFireLog(fire_log_id) {
    if (this.state.location !== "") {
      return <FireLog id={this.state.location} fire_log_id={fire_log_id} key={this.state.location} />
    }
    else {
      return <></>
    }
  }

  displayNoLocations() {
    if (this.state.locations.length === 0) {
      return (
        <p>Sorry, you don't have access to any locations. Please contact one of your admins for help.</p>
      )
    }
  }

  render() {
    const { match: { params } } = this.props;
    const { location, locations, loaded, unauthorized, error } = this.state;

    if (unauthorized) {
      return <Redirect to={{ pathname: '/login', fireLogLocation: location }}/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div>
          <PopupBox />
          <SetTitle title={"Fire Log"} />

          <EmergencyHeader />

          <div className="main-page">
            <h2 className="page-title no-print">Locations</h2>
            <OrganisationName className="no-print" />

            <div className="export-selection no-print">
              <label className="column">Select a Location:</label>
              <select name="location" value={location} onChange={this.handleChange} data-testid="select-locations">
                {locations.map((location) => (
                  <option value={location.id} key={location.id}>{location.name}</option>
                ))}
              </select>
            </div>

            { this.displayNoLocations() }

            <div className="widgets">
              {this.displayFireLog(params.fire_log_id)}
            </div>
          </div>

        </div>
      );
    }
  }

  getLocationId(data) {
    if (data.length > 0) {
      return data[0].id
    }
    else {
      return ""
    }
  }

  componentDidMount() {
    // use email param as an autofill candidate for the login screen
    const params = new URLSearchParams(this.props.location.search)
    const loginEmail = params.get('email')
    const location = params.get('location')?.toString()

    if (loginEmail) {
      sessionStorage.setItem("loginEmail", loginEmail)
      this.setState({ emailSet: true })
      this.props.history.push(`/fire-log?location=${location}`)
    }

    // use location param to set the currently selected location
    if (location) {
      this.setState({ location: location })
    }

    request("GET", `/v1/a/locations/names_and_ids`, "", () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.removeItem("loginEmail")
        this.setState({ location: location || this.getLocationId(data), locations: data, loaded: true })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default FireLogIndex;
